/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * The successful OAuth2 token response returned by `POST /api/connect/token`. Both the
 * `password` and `refresh_token` grants return this same shape — the refresh token itself is
 * never in the body; it is delivered/rotated through the HttpOnly `refresh-token` cookie. This type
 * is for documentation only; the response is produced by OpenIddict.
 * @export
 * @interface TokenResponseModel
 */
export interface TokenResponseModel {
    /**
     * The token type — always `Bearer`.
     * @type {string}
     * @memberof TokenResponseModel
     */
    tokenType?: string | null;
    /**
     * The access-token lifetime, in seconds.
     * @type {number}
     * @memberof TokenResponseModel
     */
    expiresIn?: number;
    /**
     * 
     * @type {string}
     * @memberof TokenResponseModel
     */
    $type?: TokenResponseModelTypeEnum;
    /**
     * The Bearer access token (JWT). Send it as `Authorization: Bearer <access_token>`.
     * @type {string}
     * @memberof TokenResponseModel
     */
    accessToken?: string | null;
}


/**
 * @export
 */
export const TokenResponseModelTypeEnum = {
    PtwPtw100WebMvcModelsTokenAuthTokenResponseModelPtwPtw100WebMvc: 'Ptw.Ptw100.Web.Mvc.Models.TokenAuth.TokenResponseModel, Ptw.Ptw100.Web.Mvc'
} as const;
export type TokenResponseModelTypeEnum = typeof TokenResponseModelTypeEnum[keyof typeof TokenResponseModelTypeEnum];



/**
 * Check if a given object implements the TokenResponseModel interface.
 */
export function instanceOfTokenResponseModel(value?: unknown): value is TokenResponseModel {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(TokenResponseModelTypeEnum)[0];
}

export function TokenResponseModelFromJSON(json: any): TokenResponseModel {
    return TokenResponseModelFromJSONTyped(json, false);
}

export function TokenResponseModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenResponseModel {
    if (json == null) {
        return json;
    }
    return {
        
        'tokenType': json['token_type'] == null ? undefined : json['token_type'],
        'expiresIn': json['expires_in'] == null ? undefined : json['expires_in'],
        '$type': json['$type'] == null ? undefined : json['$type'],
        'accessToken': json['access_token'] == null ? undefined : json['access_token'],
    };
}

export function TokenResponseModelToJSON(value?: TokenResponseModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'token_type': value['tokenType'],
        'expires_in': value['expiresIn'],
        '$type': value['$type'],
        'access_token': value['accessToken'],
    });
}

